import React from "react";
import { ReCaptchaProvider } from "@wss/re-captcha";
import { User } from "~/common/Store/models/User";
import PlusShipping from "../PlusShipping";
import { QuantityDiscount } from "../../ProductDetailPageResult";
import A from "./A";
import B from "./B";
import C from "./C";
import D from "./D";
import E from "./E";
import F from "./F";
import G from "./G";
import H from "./H";
import I from "./I";
import J from "./J";
import K from "./K";
import L from "./L";
import M from "./M";
import N from "./N";
import O from "./O";
import P from "./P";
import Q from "./Q";
import S from "./S";
import T from "./T";
import U from "./U";
import V from "./V";
import W from "./W";
import X from "./X";
import Y from "./Y";
import Z from "./Z";
import PriceLabel from "../PriceLabel";
import StandardPrice from "../StandardPrice";
import { PricingProduct } from "~/ProductDetails/Pricing/PricingProduct";
export interface VariantProps {
  price: PricingProduct["price"];
  unitOfMeasure: string;
  user: User;
  showBelowMinimumAdvertisedPriceForLoggedInCustomers: boolean;
  hasFreeShipping: boolean;
  hasWebPlusDiscountedShipping: boolean;
  isWebstaurantPlusEligible: boolean;
  itemNumber: string;
  minimumBuy: PricingProduct["minimumBuy"];
  mustBuy: PricingProduct["mustBuy"];
  isGoogleView: boolean;
}
interface Props {
  product: PricingProduct;
  user: User;
  isGoogleView?: boolean;
  quantityDiscounts?: QuantityDiscount[];
}
const MapVariants: {
  [key: string]: (props: VariantProps) => JSX.Element;
} = {
  A,
  B,
  C,
  D,
  E,
  F,
  G,
  H,
  I,
  J,
  K,
  L,
  M,
  N,
  O,
  P,
  Q,
  S,
  T,
  U,
  V,
  W,
  X,
  Y,
  Z
};
const MapPrice = ({
  product,
  user,
  isGoogleView = false
}: Props) => {
  const {
    price,
    unitOfMeasure,
    hasFreeShipping,
    hasWebPlusDiscountedShipping,
    isWebstaurantPlusEligible,
    showBelowMinimumAdvertisedPriceForLoggedInCustomers,
    itemNumber,
    minimumBuy,
    mustBuy,
    divideByUnit,
    divideQuantity
  } = product;
  const variantProps = {
    unitOfMeasure,
    price,
    user,
    showBelowMinimumAdvertisedPriceForLoggedInCustomers,
    hasFreeShipping,
    hasWebPlusDiscountedShipping,
    isWebstaurantPlusEligible,
    itemNumber,
    minimumBuy,
    mustBuy,
    isGoogleView,
    divideByUnit,
    divideQuantity
  };
  const MapVariant = MapVariants[price.minimumAdvertisedPriceProperties.type];
  if (MapVariant) return <ReCaptchaProvider>
        <MapVariant {...variantProps} />
      </ReCaptchaProvider>;

  // Default display for new MAP style that we don't have in code
  return <>
      <PriceLabel product={product} user={user} data-sentry-element="PriceLabel" data-sentry-source-file="index.tsx" />
      <StandardPrice price={price.price} unitOfMeasure={unitOfMeasure} divideByUnit={divideByUnit} divideQuantity={divideQuantity} data-sentry-element="StandardPrice" data-sentry-source-file="index.tsx" />
      {isWebstaurantPlusEligible && <PlusShipping text="Ships free with " />}
    </>;
};
export default MapPrice;